const initState = {
  hoverId: null,
  activeId: null,
};

const ui = (state = initState, action = {}) => {
  switch (action.type) {
    case 'SET_HOVER_ID':
      return {
        ...state,
        hoverId: action.payload,
      };
    case 'SET_ACTIVE_ID':
      return {
        ...state,
        activeId: action.payload,
      };
    default:
      return state;
  }
};

export default ui;
